// extracted by mini-css-extract-plugin
export default {"shalinaLink":"hyperLink_shalinaLink__TzJoO","shalinaLinkDisable":"hyperLink_shalinaLinkDisable__L2tC0"};